import { createBook } from '@/data/services/bookServices';
import { BookStyleEnum } from '@/models/Book';
import { TempLesson } from '@/models/Lesson';

function shouldCreateBook(lesson: TempLesson): boolean {
  return Boolean(lesson.chapters?.length && !lesson.book?.id);
}

function createBookObject(bookId: number) {
  return {
    id: bookId,
    bookStyle: BookStyleEnum.APRESENTATION,
  };
}

export async function performUpdateLessonBooks(
  _currentLessons: TempLesson[],
  newLessons: TempLesson[],
): Promise<TempLesson[]> {
  const updatedLessons: TempLesson[] = [];

  for (const newLesson of newLessons) {
    if (shouldCreateBook(newLesson)) {
      const book = await createBook({
        lessonId: newLesson.id,
        bookType: 'STUDENT',
      });

      const lessonWithBook = Object.assign({}, newLesson, {
        book: createBookObject(book.id),
      });
      updatedLessons.push(lessonWithBook);
      continue;
    }

    updatedLessons.push(newLesson);
  }

  return updatedLessons;
}

async function performCreateLessonBook(lesson: TempLesson) {
  const book = await createBook({ lessonId: lesson.id, bookType: 'STUDENT' });

  const tempLesson = new TempLesson(
    Object.assign({}, lesson, {
      book: createBookObject(book.id),
    }),
  );

  return tempLesson;
}

export async function performCreateLessonBooks(lessons: TempLesson[]) {
  const lessonsWithBooks: TempLesson[] = [];

  for (const lesson of lessons) {
    if (!lesson.chapters?.length) continue;

    const lessonWithBook = await performCreateLessonBook(lesson);
    lessonsWithBooks.push(lessonWithBook);
  }

  return lessonsWithBooks;
}
